import { UserCircleIcon } from '@airship-platform/jam-web/icons';
import Button, { ButtonProps } from '@mui/material/Button';
import { Link } from 'react-router';

type CustomerContactsButtonProps = ButtonProps & {
  customerName: string;
  to?: string;
};

const CustomerContactsButton: React.FC<CustomerContactsButtonProps> = ({
  customerName,
  to = 'contacts',
  ...props
}) => (
  <Button
    component={Link}
    color="softGold"
    startIcon={<UserCircleIcon />}
    to={to}
    {...props}
  >
    {`Contact ${customerName.trim().split(' ').at(0) || 'customer'}`}
  </Button>
);

export default CustomerContactsButton;
